export default __webpack_public_path__ + "static/media/NoPictureAvailable.a5695449.png";